/**
 * Shared CRM dropdown options for manual lead creation (Quick Add + Full Add).
 */

export const KIND_OPTIONS = [
  { value: "standort", label: "Standortlead" },
  { value: "gruender", label: "Gründerlead" },
  { value: "kontakt", label: "Kontaktanfrage" },
  { value: "dev_program", label: "Dev-Programm" },
  { value: "sales_partner", label: "Sales Partner" },
];

export const SOURCE_TYPE_OPTIONS = [
  { value: "manual", label: "Manuell" },
  { value: "phone", label: "Telefon" },
  { value: "trade_fair", label: "Messe" },
  { value: "linkedin", label: "LinkedIn" },
  { value: "email", label: "E-Mail" },
  { value: "referral", label: "Empfehlung" },
  { value: "sales_partner", label: "Sales Partner" },
  { value: "existing_contact", label: "Bestandskontakt" },
  { value: "instagram", label: "Instagram" },
  { value: "facebook", label: "Facebook" },
  { value: "whatsapp", label: "WhatsApp" },
  { value: "network_event", label: "Netzwerk-Event" },
  { value: "direct_meeting", label: "Persönliches Gespräch" },
  { value: "other", label: "Sonstige" },
];

export const PRIORITY_OPTIONS = [
  { value: "low", label: "Niedrig" },
  { value: "normal", label: "Normal" },
  { value: "high", label: "Hoch" },
  { value: "urgent", label: "Dringend" },
];
